import React from "react";
import HeroSection from "./../components/HeroSection";
import FeaturesSection from "./../components/FeaturesSection";
import TestimonialsSection from "./../components/TestimonialsSection";
import CtaSection from "./../components/CtaSection";
import FeaturesSection2 from "./../components/FeaturesSection2";
import NewsletterSection from "./../components/NewsletterSection";
import ClientsSection from "./../components/ClientsSection";
import { useRouter } from "./../util/router.js";

function IndexPage(props) {
  const router = useRouter();

  return (
    <>
      <HeroSection
        bg="primary"
        textColor="info"
        size="lg"
        buttonText="Get Started"
        bgImage="https://fitrace.s3.amazonaws.com/FitRaceBanner3.png"
        bgImageOpacity={1}
        title="Race to your fitness goals"
        subtitle=""
        buttonColor="info"
        buttonOnClick={() => {
          // Navigate to pricing page
          router.push("/auth/:type");
        }}
      ></HeroSection>
      <FeaturesSection
        bg="white"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        title="1-on-1 Judged Competitions for Cash Prizes"
        subtitle="Imagine you enter a marathon but instead of thousands of people racing, it's just you and your closest competitor racing for a cash prize. Turned every workout into a judged competition and race to your fitness goals. "
      ></FeaturesSection>
      <TestimonialsSection
        bg="white"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        title="Here's what people are saying"
        subtitle=""
      ></TestimonialsSection>
      <CtaSection
        bg="primary"
        textColor="light"
        size="sm"
        bgImage=""
        bgImageOpacity={1}
        title="Ready to get started?"
        subtitle=""
        buttonText="Get Started"
        buttonColor="light"
        buttonOnClick={() => {
          // Navigate to pricing page
          router.push("/pricing");
        }}
      ></CtaSection>
      <FeaturesSection2
        bg="white"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        title="How FitRace Works"
        subtitle="FitRace brings the power and excitement of competitive health and fitness to the everyday workouts you do on your schedule."
      ></FeaturesSection2>
      <NewsletterSection
        bg="light"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        title="Stay in the know"
        subtitle="Receive our latest articles and feature updates"
        buttonText="Subscribe"
        buttonColor="primary"
        inputPlaceholder="Enter your email"
        subscribedMessage="You are now subscribed!"
      >
        <ClientsSection
          bg="light"
          textColor="dark"
          size="md"
          bgImage=""
          bgImageOpacity={1}
          title="FitRace is a part of company culture at..."
          subtitle=""
        ></ClientsSection>
        <FeaturesSection2
          bg="white"
          textColor="dark"
          size="md"
          bgImage=""
          bgImageOpacity={1}
          title="Features"
          subtitle="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud."
        ></FeaturesSection2>
      </NewsletterSection>
    </>
  );
}

export default IndexPage;
